import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Typography from '@mui/material/Typography';
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles';
import customTheme from '../../components/customTheme';
import NetRisePlainLogo from '../../NRIcons/NetRisePlainLogo';
import { SSO_TEST_COMPLETE_LABELS } from './NRSSOTestComplete.constants';

// The SAML test tab lands here with no NetRise session, so this page renders outside <App />
// and carries its own theme. It must not read the query string or call an API: the wizard tab
// owns the verdict and closes this tab once its poll resolves.
function NRSSOTestComplete() {
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={customTheme}>
        <CssBaseline enableColorScheme />
        <Box
          sx={{
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 1.5,
            px: 3,
            textAlign: 'center',
            backgroundColor: 'background.default'
          }}
        >
          <Box sx={{ color: 'primary.main', display: 'flex' }} aria-hidden>
            <NetRisePlainLogo height="42" width="48" />
          </Box>
          <Typography variant="h3" component="h1">
            {SSO_TEST_COMPLETE_LABELS.TITLE}
          </Typography>
          <Typography variant="body2" color="textSecondary" sx={{ maxWidth: 400 }}>
            {SSO_TEST_COMPLETE_LABELS.DESCRIPTION}
          </Typography>
        </Box>
      </ThemeProvider>
    </StyledEngineProvider>
  );
}

export default NRSSOTestComplete;
